import { AUTH_API } from "../config/config";

async function postRelay(path, body) {
  const response = await fetch(`${AUTH_API}/auth/developer/relay/${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(`Developer authentication failed (${response.status}).`);
  }
  return payload?.data && typeof payload.data === "object"
    ? payload.data
    : payload;
}

export async function checkDeveloperPairingRelay(relayId, pairingCode) {
  const result = await postRelay("check", {
    flow: "pairing",
    relayId,
    pairingCode,
  });
  if (result.success !== true) {
    throw new Error("The Meow pairing code is invalid or expired.");
  }
}

export async function checkDeveloperCallbackRelay(relayId, loginTicket) {
  const result = await postRelay("check", {
    flow: "callback",
    relayId,
    loginTicket,
  });
  if (result.success !== true) {
    throw new Error("This developer login request is invalid or expired.");
  }
  return result;
}

export async function saveDeveloperAuthRelay(authState) {
  const result = await postRelay("save", authState);
  if (result.success !== true) {
    throw new Error("Unable to send the developer session to Meow.");
  }
  return result;
}
